import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IUntitledTextEditorService = ( createDecorator('untitledTextEditorService'));
export { IUntitledTextEditorService };
